import React from 'react'
import LgyLink from 'app/components/util/lgy-link/LgyLink'
import { LgySubsection } from 'app/components/util/lgy-section/LgySection'
import { formatUnixDateStringToDisplayString } from 'app/utils/dateTimeUtils'
import { } from 'react-icons/md'

const JobRuns = ({ job }) =>
  <LgySubsection header='Run History'>
    <table className='usa-table-borderless'>
      <thead>
        <tr>
          <th scope='col'>Start Date</th>
          <th scope='col'>End Date</th>
          <th scope='col'>Started By</th>
          <th scope='col'>Result</th>
          <th scope='col'>Details</th>
        </tr>
      </thead>
      <tbody>
        {job.runs.map(run => <tr key={run.id}>
          <td>{formatUnixDateStringToDisplayString(run.startDate)}</td>
          <td>{run.endDate ? formatUnixDateStringToDisplayString(run.endDate) : 'N/A'}</td>
          <td><LgyLink to={`/lgyhub/admin/users/${run.userStartedById}`}>{run.userStartedBy}</LgyLink></td>
          <td>{run.endDate === null
            ? 'Running'
            : run.success
              ? 'Success'
              : 'Failure'}</td>
          <td>
            <LgyLink title='Job Details' to={`/lgyhub/admin/jobs/${job.name}/${run.id}`}>Details</LgyLink></td>
        </tr>)}
      </tbody>
    </table>
  </LgySubsection>

export default JobRuns